import { ParentBusiness, Fcapp, CommonService } from 'fccore2';
/**
 * æ ¹æ®æ¨¡åappidè·åæ¨¡åãæ¨¡åå­æ®µãæ¨¡åéªè¯ç 
 * @param appId æ¨¡åid
 */
export function initAppData(appId: string) {
    if (appId) {
        const mainApp: Fcapp = ParentBusiness.appService.getAppById(appId);
        if (mainApp) {
            const mainListFields = ParentBusiness.appService.getListFieldsByApp(mainApp);
            let showListFields = '';
            mainListFields.forEach(field => {
                showListFields += field.FIELDCODE + ',';
            });
            const mainFormFields = ParentBusiness.appService.getFormFieldsByApp(mainApp);
            let showFormFields = '';
            mainFormFields.forEach(field => {
                showFormFields += field.FIELDCODE + ',';
            });
            const mainValid = initValid(mainFormFields);
            const mainObj = ParentBusiness.appService.initObjDefaultValue(mainApp);
            const searchObj = mainApp.SYSAPPFIELDS.filter(i => i.ENABLESEARCH === 'Y');
            return {mainObj, showListFields, showFormFields, mainApp, mainListFields, mainFormFields, mainValid, searchObj};
        }
    }
    // return {mainApp: {}, mainListFields: {}, mainFormFields: {}, searchObj: {}, mainValid: {}};
    return null;
}
/**
 * è·åå¯¹è±¡çåå§åå¼
 * @param appId æ¨¡åç¼ç 
 */
export function initObjDefaultValue(appId: string) {
    if (appId) {
        const mainApp: Fcapp = ParentBusiness.appService.getAppById(appId);
        if (mainApp) {
            return ParentBusiness.appService.initObjDefaultValue(mainApp);
        }
    }
    return null;
}

/**
 * åå§åæ ¡éªè§å
 * @param mainFields ææå­æ®µ
 */
export function initValid(mainFields: any[]): any {
    const mainValid: any = {};
    mainFields.forEach(field => {
        const val: any = {};
        val.show = 'N';
        val.showValidator = '';
        val.validators = {
            required: field.ISNULL === 'Y', // Yçæ¶åå¿å¡«
            maxLength: field.LENGTH,
            customVal: false
        };
        val.errorMessages = {
            required: field.FIELDNAME + 'ä¸è½ä¸ºç©º.',
            maxLength: 'æå¤§è¾å¥å­æ°ä¸è½è¶è¿' + field.LENGTH + 'å­.',
            customVal: 'èªå®ä¹éªè¯',
        };
        val.fieldCode = field.FIELDCODE;
        mainValid[field.FIELDCODE] = val;
    });
    return mainValid;
}

/**
 * å¯¹æ¥æå¤çï¼ææ¶é´æ³ä¿®æ¹ä¸ºæ¥ææ ¼å¼
 */
export function  initValue(mainObj: any, mainFields: any[]): void {
    Object.keys(mainObj).forEach(fieldCode => {
        const fields = mainFields.filter(field => field.FIELDCODE === fieldCode);
        if (fields.length > 0) {
            const field = fields[0];
            switch (field.DBTYPE) {
                case 'DATE':
                    mainObj[field.FIELDCODE] = CommonService.stringToDate(mainObj[field.FIELDCODE]);
                    break;
            }
        }
    });
}
/**
 * å¯¹æ¥æå¤çï¼ææ¥ææ¶é´æ ¼å¼ä¿®æ¹ä¸ºæ¶é´æ³
 */
export function  processValue(mainObj: any, mainFields: any[]): any {
    const mainObj1 = Object.assign({}, mainObj, {DOACTION: ''});
    Object.keys(mainObj).forEach(fieldCode => {
        const fields = mainFields.filter(field => field.FIELDCODE === fieldCode);
        if (fields.length > 0) {
            const field = fields[0];
            switch (field.DBTYPE) {
                case 'DATE':
                    mainObj1[field.FIELDCODE] = CommonService.dateFormat(mainObj[field.FIELDCODE], 'yyyy-MM-dd hh:mm:ss');
                    break;
            }
        }
    });
    return mainObj1;
}
/**
 * éªè¯
 */
export function  validator(mainObj: any, mainValid: any, checkKey?: string): boolean {
    let flag = true;
    Object.keys(mainValid).forEach(key => {
        if ((checkKey && checkKey === key) || checkKey === null || checkKey === undefined) {
            const val = mainValid[key];
            val.show = 'N';
            /** å½åä¸»å¯¹è±¡çå­æ®µå¼ */
            const value = mainObj[val.fieldCode] || '';
            /** å½åä¸»å¯¹è±¡çæ ¡éªè§å */
            const valid = val.validators;
            /** å½åä¸»å¯¹è±¡æ ¡éªè§åéè¯¯è¯´æ */
            const message = val.errorMessages;
            /** å¤æ­æ¯å¦å¿å¡« */
            if (valid.required && (undefined === value || null == value || value.length === 0)) {
                val.show = 'Y';
                val.showValidator = 'required';
                flag = false;
            } else if (value && value.length > valid.maxLength) {
                val.show = 'Y';
                val.showValidator = 'maxLength';
                flag = false;
            } else if (valid.customVal) {
                val.show = 'Y';
                val.showValidator = 'customVal';
                flag = false;
            }
            mainValid[key] = val;
        }
    });
    return flag;
}
/**
 * ä¿å­æ°å»º
 * @param mainApp å½ååæ°æ®
 * @param mainObj å½åå¯¹è±¡
 * @param mainValid æ ¡éªè§å
 * @param mainFields å½ååæ°æ®å­æ®µ
 * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
 * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
 */
export function  saveNew(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: () => boolean, afterSave: (result) => void, pthis: any): void {
    if (!this.validator(mainObj, mainValid)) {
        return;
    }
    if (beforeSave()) {
        pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
            this.processValue(mainObj, mainFields)).subscribe(result => {
                if (result.CODE === '0') {
                    ParentBusiness.msgService.message('ä¿å­æåï¼');
                    afterSave(result);
                    mainObj = ParentBusiness.appService.initObjDefaultValue(mainApp);
                } else {
                    ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                }
            }));
    }
}
/**
 * ä¿å­å¤å¶
 * @param mainApp å½ååæ°æ®
 * @param mainObj å½åå¯¹è±¡
 * @param mainValid æ ¡éªè§å
 * @param mainFields å½ååæ°æ®å­æ®µ
 * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
 * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
 */
export function  cardSaveCopy(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: () => boolean, afterSave: (result) => void, pthis: any): void {
    if (!this.validator(mainObj, mainValid)) {
        return;
    }
    if (beforeSave()) {
        pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
            this.processValue(mainObj, mainFields)).subscribe(result => {
                if (result.CODE === '0') {
                    ParentBusiness.msgService.message('ä¿å­æåï¼');
                    afterSave(result);
                    mainObj.ID = '';
                } else {
                    ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                }
            }));
    }
}
/**
 * ä¿å­å¤å¶
 * @param mainApp å½ååæ°æ®
 * @param mainObj å½åå¯¹è±¡
 * @param mainValid æ ¡éªè§å
 * @param mainFields å½ååæ°æ®å­æ®µ
 * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
 * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
 */
export function  cardSave(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: () => boolean, afterSave: (result) => void, pthis: any): void {
    if (!this.validator(mainObj, mainValid)) {
        return;
    }
    if (beforeSave()) {
        pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
            this.processValue(mainObj, mainFields)).subscribe(result => {
                if (result.CODE === '0') {
                    ParentBusiness.msgService.message('ä¿å­æåï¼');
                    afterSave(result);
                } else {
                    ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                }
            }));
    }
}
/**
 * ä¿å­è¿åæ¹æ³
 * @param mainApp å½ååæ°æ®
 * @param mainObj å½åå¯¹è±¡
 * @param mainValid æ ¡éªè§å
 * @param mainFields å½ååæ°æ®å­æ®µ
 * @param beforeSave ä¿å­æ ¡éªæ¯å¦éè¿çåè°æ¹æ³
 * @param afterSave ä¿å­ä¹åçå¤çæ¹æ³
 * @param cardBack è°ç¨è¿åæ¹æ³
 */
export function  cardSaveBack(mainApp: any, mainObj: any, mainValid: any, mainFields: any[], beforeSave: () => boolean, afterSave: (result) => void, cardBack: () => void, pthis: any): void {
    if (!this.validator(mainObj, mainValid)) {
        return;
    }
    if (beforeSave()) {
        pthis.pushDestroy(ParentBusiness.appService.saveObject(mainApp.APPID,
            this.processValue(mainObj, mainFields)).subscribe(result => {
                if (result.CODE === '0') {
                    ParentBusiness.msgService.message('ä¿å­æåï¼');
                    afterSave(result);
                    cardBack();
                } else {
                    ParentBusiness.msgService.message('ä¿å­å¤±è´¥ï¼');
                }
            }));
    }
}
/**
 * ä¿®æ¹ä¸ºæä¸ªæ¨¡åå±æ§çå¼
 * @param mainObj å¯¹è±¡
 * @param fieldCode å±æ§åç§°
 * @param value å±æ§å¼
 */
export function  setFieldValue(mainObj: any, fieldCode: string, value: any): any {
    mainObj[fieldCode] = value;
}
